import { useGeoMasterDataApi } from "@/features/core-shared/composables/useGeoMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useGeoCountriesMasterdataQuery() {
  const geoMasterDataApi = useGeoMasterDataApi();
  return useQuery({
    queryKey: ["geo-countries-masterdata"],
    queryFn: () => geoMasterDataApi.getCountries(),
    select: ({ data }) => data,
  });
}
